/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import { useState, useEffect } from "react";
import { getAllTransactions } from "services/transactionService";
import dayjs from "dayjs";

// Images
import team2 from "assets/images/team-2.jpg";

function Author({ image, name, email }) {
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} name={name} size="sm" variant="rounded" />
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="button" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

const AllTransactionTableData = (filters = {}) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  });

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      const params = {};

      // Add filters
      if (filters.fromDate) {
        params.fromdate = dayjs(filters.fromDate).format("YYYY-MM-DD");
      }
      if (filters.toDate) {
        params.todate = dayjs(filters.toDate).format("YYYY-MM-DD");
      }
      if (filters.method) {
        params.method = filters.method.toUpperCase();
      }

      // Add pagination params
      if (filters.page) {
        params.page = filters.page;
      }
      if (filters.limit) {
        params.limit = filters.limit;
      }

      const response = await getAllTransactions(params);

      if (response.success) {
        setTransactions(response.data);
        // Store pagination metadata from backend
        if (response.pagination) {
          setPagination(response.pagination);
        }
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [filters]);

  const columns = [
    { name: "sno", align: "center" },
    { name: "Timestamp", align: "left" },
    { name: "User", align: "left" },
    { name: "Update type", align: "left" },
    { name: "method", align: "left" },
    // { name: "payment type", align: "left" },
    { name: "Fees Type", align: "left" },
    { name: "credit amount", align: "center" },
    { name: "debit amount", align: "center" },
  ];

  const rows = transactions.map((transaction, index) => {
    // Check if it's a parent or tutor transaction
    const user = transaction.parentId || transaction.tutorId;
    const userName = user?.fullName || "N/A";
    const userEmail = user?.email || "N/A";
    const userImage =
      transaction.tutorId?.profileImage || transaction.parentId?.profileImage || null;

    return {
      sno: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {index + 1}
        </ArgonTypography>
      ),
      Timestamp: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {dayjs(transaction.createdAt).format("DD MMMM YYYY")}
        </ArgonTypography>
      ),
      User: <Author image={userImage} name={userName} email={userEmail} />,
      "Update type": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {transaction.transactionType?.toUpperCase() || "N/A"}
        </ArgonTypography>
      ),
      method: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {transaction.method?.toUpperCase() || "N/A"}
        </ArgonTypography>
      ),
      // "payment type": (
      //   <ArgonTypography variant="caption" color="text" fontWeight="medium">
      //     {transaction.paymentType || "N/A"}
      //   </ArgonTypography>
      // ),
      "Fees Type": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {transaction.FeesType ? transaction.FeesType.replace(/_/g, " ") : "N/A"}
        </ArgonTypography>
      ),
      "credit amount": (
        <ArgonTypography
          variant="caption"
          color={transaction.transactionType === "CREDIT" ? "success" : "text"}
          fontWeight="medium"
        >
          {transaction.transactionType === "CREDIT"
            ? `₹${transaction.amount?.toLocaleString()}`
            : "-"}
        </ArgonTypography>
      ),
      "debit amount": (
        <ArgonTypography
          variant="caption"
          color={transaction.transactionType === "DEBIT" ? "error" : "text"}
          fontWeight="medium"
        >
          {transaction.transactionType === "DEBIT"
            ? `₹${transaction.amount?.toLocaleString()}`
            : "-"}
        </ArgonTypography>
      ),
    };
  });

  return {
    columns,
    rows,
    loading,
    fetchTransactions,
    pagination,
  };
};

export default AllTransactionTableData;
